import React, { useEffect } from "react";
import InteriorImg from '../Images/Interiors.jpg';
import UrlTag from "../components/UrlTag";
import { Link } from "react-router-dom";

function Interiors() {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="z-20">
            <UrlTag />
            <div className="relative">
                <img src={InteriorImg} alt="Engineering" className="w-full h-[300px] md:h-[500px] object-cover" />
                <div className="absolute inset-0 bg-black opacity-40"></div>
                <div className="absolute bottom-0 left-0 py-4 md:py-8 px-4 md:px-14">
                    <h1 className="text-white text-2xl md:text-4xl font-bold">Interiors</h1>
                </div>
            </div>
            <div className="p-4 md:p-16 max-w-[620px] mx-auto">
                <div className="mb-10">
                    <h1 className="text-xl md:text-2xl mb-4 tracking-wider">
                        Interiors at Architetive Designs
                    </h1>
                    <p className="text-base md:text-lg mb-6 tracking-wider text-gray-700 font-light">
                        By designing a building from the inside-out as much as from the outside-in, we inculcate a sense of continuity and connection to the wider world. The starting point for any design solution is to gain an understanding of people’s needs and the way in which a space will be used. The goal is the creation of interiors that are both functional and elegant, while evoking a sense of place and complementing a building’s outward expression.
                    </p>
                </div>
                <div className="flex flex-row gap-4">
                    <Link to='/people'>
                        <button className="text-gray-500 bg-[#eeeeee] hover:bg-[#e6e6e6] rounded-full px-4 py-1">People</button>
                    </Link>
                    <Link to='/contact'>
                        <button className="text-gray-500 bg-[#eeeeee] hover:bg-[#e6e6e6] rounded-full px-4 py-1">Contact</button>
                    </Link>
                    <Link to='/careers/vacancies'>
                        <button className="text-gray-500 bg-[#eeeeee] hover:bg-[#e6e6e6] rounded-full px-4 py-1">Vacancies</button>
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default Interiors;